
import { referralCodeParameterName, getReferralCode } from './referral-code.js';

import Request from './request.js';


(function(jQuery) {
  jQuery(document).ready(function($) {
    const referralCode = getReferralCode();

    $('[data-sbm-pricing-table]').each(function(e) {
      var pricingTable = $(this);
      var bigPrice = pricingTable.find('.price-big');
      var activeOpt = pricingTable.find('.price-item.active')
      var data = activeOpt.find('.price-data').html()
      var link = activeOpt.find('a');
      var linkBtn = link.attr('href')
      var plan = activeOpt.find($('.plan-data'))
      var planData = plan.html();
      var billData =  pricingTable.find('.bill-txt');
      var priceCompare =  pricingTable.find('.compare-price');
      var salePriceComp = priceCompare.find('.sale-price')
      var regPriceComp = priceCompare.find('.reg-price')
      var regPrice = activeOpt.find('.regular-price .wpcs_price')
      var regTxt = regPrice.text()
      var salePrice = activeOpt.find('a.price-data .wpcs_price').text();
      var select = pricingTable.find('.price-item')
      var memberButton = pricingTable.find('.member-btn a');
      bigPrice.html(data);

      if (regPrice.length) {
        regPriceComp.text(regTxt)
        regPriceComp.show()
      } else {
        regPriceComp.hide()
      }
      $(salePriceComp).text(salePrice)

      var setCtaUrl = function(href) {
        if (memberButton.length) {
          if (referralCode) {
            href = Request.updateQueryStringParameter(
              href,
              referralCodeParameterName,
              referralCode
            );
          }

          memberButton.attr('href', href);
        }
      };

      // set the member button to the active link on load.
      setCtaUrl(linkBtn);

      if ($(activeOpt).data('saving')) {
        var saving = $(activeOpt).data('saving')
        var savingItem = `<div class="saving">Save ${saving}</div>`
        $('.saving').remove();
        $(savingItem).insertAfter('.price-plan')
      }

      billData.text('Billed ' + planData)

      select.click(function(event) {
        event.preventDefault()
        var priceItem = pricingTable.find('.price-item')
        priceItem.removeClass('active')
        $(this).addClass('active')
        var data = $(this).find('.price-data')
        var priceData = $(data).html();
        var bigPrice = pricingTable.find($('.price-big'))
        var link = $(this).find('a');
        var linkBtn = $(link).attr('href')
        var plan = $(this).find('.plan-data')
        var planData = $(plan).html();
        var billData = pricingTable.find($('.bill-txt'));
        var priceCompare = pricingTable.find('.compare-price');
        var salePriceComp = priceCompare.find('.sale-price')
        var regPrice = $(this).find('.regular-price')
        var regTxt = regPrice.text()
        var salePrice = $(this).find('a.price-data .price-val').text();

        $(bigPrice).html(`${priceData}`);
        setCtaUrl(linkBtn);
        $(billData).text(`Billed ${planData}`)

        if ($(regPrice).length) {
          regPriceComp.text(`${regTxt}`)
          regPriceComp.show()
        } else {
          regPriceComp.hide()
        }
        $(salePriceComp).text(salePrice)

        var saving = $(this).data('saving')
        var savingItem = `<div class="saving">Save ${saving}</div>`
        var thisSavingitem = pricingTable.find($('.saving'))
        var pricePlan = pricingTable.find($('.price-plan'))
        pricingTable.find($('.saving')).remove();


        if (typeof $(this).data('saving') !== 'undefined') {
          $(savingItem).insertAfter($(pricePlan))
          setTimeout(function(){ 
            $(thisSavingitem).css('opacity', '1');
          }, 50);
        } else {
          $(savingItem).insertAfter($(pricePlan))
          var thisSavingitem = pricingTable.find($('.saving'))

          setTimeout(function(){ 
            $(thisSavingitem).css('opacity', '0');
          }, 10);
        }
      })
    })
  });
})(jQuery);

